import React from "react";

interface ProgressBarProps {
  value: number;
  max: number;
  colorClass?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max,
  colorClass = "al-bg-green-500",
}) => {
  const pct = max > 0 ? (value / max) * 100 : 0;
  return (
    <div className="al-w-full al-bg-gray-200 al-rounded-full al-h-2.5">
      <div className={`al-h-2.5 al-rounded-full ${colorClass}`} style={{ width: `${pct}%` }} />
    </div>
  );
};
